import React from 'react';
import { TextField, MenuItem } from '@mui/material';
import { Currency } from '../../types/PaymentLink';
import { getAvailableCurrencies } from '../../utils/validators';

interface CurrencySelectProps {
  value: Currency;
  onChange: (currency: Currency) => void;
  disabled?: boolean;
  required?: boolean;
  fullWidth?: boolean;
  error?: boolean;
  helperText?: string;
}

const CurrencySelect: React.FC<CurrencySelectProps> = ({
  value,
  onChange,
  disabled = false,
  required = false,
  fullWidth = true,
  error = false,
  helperText,
}) => {
  const currencies = getAvailableCurrencies();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as Currency);
  };

  return (
    <TextField
      select
      fullWidth={fullWidth}
      label="Currency"
      value={value}
      onChange={handleChange}
      disabled={disabled}
      required={required}
      error={error}
      helperText={helperText}
    >
      {currencies.map((currency) => (
        <MenuItem key={currency.code} value={currency.code}>
          {currency.code} ({currency.symbol}) - {currency.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default CurrencySelect;
